export const UserType = Object.freeze({
    ADMIN: 'admin',
    MEMBER: 'member',
});

export default UserType; // REMOVE THIS LINE WHENEVER A NEW NAMED EXPORT IS ADDED INTO THIS FILE. Currently, I'm adding this default export to suppress the `import/prefer-default-export` ESLint error.
